var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPishroLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4978_80226)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4978_80226",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4978_80226)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.993,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59375 7.07031C17.5817 7.07031 29.5706 7.07031 41.5586 7.07031C41.5586 10.4956 41.5586 13.9207 41.5586 17.346C29.5706 17.346 17.5817 17.346 5.59375 17.346C5.59375 13.9207 5.59375 10.4956 5.59375 7.07031Z",
    fill: "#099C53"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.992,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7695 19.25C25.6994 19.25 33.6285 19.25 41.5583 19.25C41.5583 22.6752 41.5583 26.1003 41.5583 29.5256C33.6285 29.5256 25.6994 29.5256 17.7695 29.5256C17.7695 26.1003 17.7695 22.6752 17.7695 19.25Z",
    fill: "#099C53"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2988 31.4297C34.0523 31.4297 37.8064 31.4297 41.5599 31.4297C41.5599 34.8314 41.5599 38.2332 41.5599 41.635C37.8064 41.635 34.0523 41.635 30.2988 41.635C30.2988 38.2332 30.2988 34.8314 30.2988 31.4297Z",
    fill: "#099C53"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4978_80226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPishroLogo);
export default __webpack_public_path__ + "static/media/pishro_logo.ef438ecb9baf9fb4ed26dbdb76b301c2.svg";
export { ForwardRef as ReactComponent };